import { ORIGINS_ICONS, ORIGINS_ICONS_SCOLLER } from '@/1001repas/origins/image';
import { initDishesRotation } from '@/fjm/_site/makers/dishes-rotation.maker';
import AppConstants from '@/shared/app/model/AppConstants';
import Site2 from '@/shared/app/model/templating/Site2';
import { DishesMock } from '@/shared/data/mocks/dishes/dishes.mock';
import { notInProduction } from '@/shared/data/mocks/not-in-production';
import { weeklyPick } from '@/shared/data/weekly/weekly-pick';
import { readActiveDishes } from '@/shared/data/whats-active/active-dishes';
import { makeUniCommunications } from '@/shared/uni/templating/components/communications/ui/maker';
import {
  makeUniAccueil,
  MakeUniAccueilOptions,
} from '@/shared/uni/templating/makers/accueil.maker';
import { getMilleEtUnTheme } from '../1_fournier_mobalpa_thones/theme';

const mock = new DishesMock({
  origins: ORIGINS_ICONS,
  maxDishes: 4,
  minDishes: 1,
  maxOrigins: 3,
  sides: true,
});
const mock1 = new DishesMock({
  maxDishes: 1,
  maxAllergens: 0,
  maxOrigins: 0,
  sides: false,
});

const AguettantLyon: Site2 = {
  pages: [
    // [7000] Accueil offre vertical
    {
      templateGetter: (state, getters) => {
        const theme1 = getMilleEtUnTheme(getters.value('dishes1', 'theme')?.toString());
        const theme2 = getMilleEtUnTheme(getters.value('dishes2', 'theme')?.toString());
        const theme3 = getMilleEtUnTheme(getters.value('dishes3', 'theme')?.toString());
        const theme4 = getMilleEtUnTheme(getters.value('dishes4', 'theme')?.toString());
        const theme5 = getMilleEtUnTheme(getters.value('dishes5', 'theme')?.toString());

        // Seuls les stands avec au moins 1 plat actif sont affichés
        const activeStandsIndexes = readActiveDishes(getters, [
          'dishes1',
          'dishes2',
          'dishes3',
          'dishes4',
          'dishes5',
        ]);
        // Récupération accompagnements
        let sides = '';
        Object.entries(activeStandsIndexes).forEach(([dataset]) => {
          const values = getters.all(dataset);
          if (values.sides) sides += `${sides.length ? ' — ' : ''}${values.sides}`;
        });
        if (process.env !== AppConstants.ENV.PRODUCTION) sides = sides.substring(0, 85);

        const stands: MakeUniAccueilOptions['stands'] = [
          {
            headerImage: theme1.headerImage,
            datasetName: 'dishes1',
          },
          {
            headerImage: theme2.headerImage,
            datasetName: 'dishes2',
          },
          {
            headerImage: theme3.headerImage,
            datasetName: 'dishes3',
          },
          {
            headerImage: theme4.headerImage,
            datasetName: 'dishes4',
          },
          {
            headerImage: theme5.headerImage,
            datasetName: 'dishes5',
          },
        ];

        const accueil = {
          component: 'AutoFlex',
          config: {
            vertical: true,
            grow: '0',
            basis: '0',
            offreGrow: '1',
            ttcBasis: '3vw',
            legumesBasis: '3.5vw',
            commBasis: '56.25vw',
          },
          slots: {
            offre: makeUniAccueil({
              backgroundColor: '#f2f2f2',
              originsIcons: ORIGINS_ICONS_SCOLLER,
              stands,
              keepStandsWithNoActiveDishes: false,
              getters,
              sizeFactor: 0.88,
              dishConfig: {
                priceTextColor: 'black',
                priceBackgroundColor: '#F7F7F7',
                centerContentInUpper: true,
              },
              dishesGroupConfig: {
                numberOfDishesPerPage: 2,
                numberOfDishesPerRow: 2,
                minNumberOfDishesPerRow: 1,
                pagesTransition: 'slideleft',
                borderRadius: '.5rem',
              },
            }),
            ...(sides
              ? {
                  legumes: {
                    component: 'TText',
                    config: {
                      text: sides,
                      color: '#858D9F',
                      padding: '0rem 1.5rem',
                      backgroundColor: '#f2f2f2',
                      textAlign: 'center',
                      fontSize: '1.8rem',
                    },
                  },
                }
              : {}),
            ttc: {
              component: 'TText',
              config: {
                text: 'Tous nos prix sont exprimés TTC',
                color: '#858D9F',
                padding: '0rem 1.5rem',
                backgroundColor: '#f2f2f2',
                textAlign: 'center',
                fontSize: '1.6rem',
              },
            },
            comm: makeUniCommunications({
              mask: {
                backgroundImage: '/storage/comm/fournier_welcome.webp',
              },
            }),
          },
        };

        return {
          component: 'Alternate',
          config: {
            transition: 'slide-left',
            accueilDuration: '15000',
            duration: '7000',
          },
          slots: {
            accueil,
          },
        };
      },
      datasets: {
        dishes1: weeklyPick('aguettant_bistrot'),
        dishes2: weeklyPick('aguettant_maraicher'),
        dishes3: weeklyPick('aguettant_etaldumarche'),
        dishes4: weeklyPick('aguettant_atelier'),
        dishes5: weeklyPick('aguettant_menueco'),
        communications: 'communications_site_69c3ed60c4f20d52f6c5622b',
      },
      default: {
        dishes1: {
          ...notInProduction(mock.make()),
          theme: 'bistrot',
        },
        dishes2: {
          ...notInProduction(mock.make()),
          theme: 'marayeur',
        },
        dishes3: {
          ...notInProduction(mock.make()),
          theme: 'etaldumarche',
        },
        dishes4: {
          ...notInProduction(mock.make()),
          theme: 'atelier',
        },
        dishes5: {
          ...notInProduction(mock.make()),
          theme: 'menueco',
        },
      },
      init() {
        initDishesRotation();
      },
    },
  ],
};

export default AguettantLyon;
